import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

interface Props {
  module: string
}

export default function ModuleRoute({ module }: Props) {
  const hasModule = useAuthStore((s) => s.hasModule)

  if (!hasModule(module)) {
    return <Navigate to="/access-denied" replace />
  }

  return <Outlet />
}
